<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-31 17:13:41
--> 
<template>
  <div>
    <mrc_ess_iconGroup
      :is_disabled="readonly"
      :showEdit="hasBtn('edit-scheduled-job')"
      :show_del="hasBtn('delete-schedule-job')"
      :showReturn="false"
      @handleEdit="handleEdit"
      @handleDel="handleDel"
    ></mrc_ess_iconGroup>

    <v-tabs
      v-model="tab"
      @change="change"
      grow
      background-color="#eeeef0"
      color="primary"
      dark
    >
      <v-tab
        v-for="(item, index) in items"
        class="text-capitalize"
        :key="index"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <timedTask
          :disabled="readonly"
          @changeReadonly="handleEdit"
        ></timedTask>
      </v-tab-item>

      <v-tab-item>
        <journal :disabled="readonly" @changeReadonly="handleEdit"></journal>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { deleteTimedTask } from "@/service/api/pushTask.js";
import timedTask from "./modules/timedTask";
import journal from "./modules/journal";
export default {
  components: {
    timedTask,
    journal,
  },
  props: {},
  data() {
    return {
      readonly: false,
      tab: null,
      list: {},
    };
  },
  computed: {
    items() {
      return [
        { tab: this.$t("label_scheduled_task_settings") },
        { tab: this.$t("label_log") },
      ];
    },
  },
  created() {},
  watch: {
    readonly: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_scheduled_tasks";
          this.$store.commit("set_page_title", "label_edit_scheduled_tasks");
        } else {
          this.$route.meta.title = "label_view_scheduled_tasks";
          this.$store.commit("set_page_title", "label_view_scheduled_tasks");
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.readonly = this.$store.state.iconstatus;
    this.tab = this.$store.state.tab;
  },
  beforeDestroy() {
    this.$store.commit("setTab", "");
  },

  methods: {
    change() {
      this.$store.commit("setTab", this.tab);
    },
    handleEdit() {
      this.readonly = !this.readonly;
      this.$store.commit("set_iconstatus", this.readonly);
    },
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then((res) => {
        deleteTimedTask({ uuid: this.$store.state.uuid }).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            this.$router.push({
              name: "timedTask",
              params: {
                type: "del",
              },
            });
          }
        });
      });
    },
  },
};
</script>

<style scoped>
</style>
